/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sessions_Tab_RecordsInputs */

const en_ui_sessions_tab_records = /** @type {(inputs: Ui_Sessions_Tab_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Records`)
};

const de_ui_sessions_tab_records = /** @type {(inputs: Ui_Sessions_Tab_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekorde`)
};

/**
* | output |
* | --- |
* | "Records" |
*
* @param {Ui_Sessions_Tab_RecordsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sessions_tab_records = /** @type {((inputs?: Ui_Sessions_Tab_RecordsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sessions_Tab_RecordsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sessions_tab_records(inputs)
	return de_ui_sessions_tab_records(inputs)
});